module.exports = __webpack_public_path__ + "static/media/Ads-02.eee4f03c.png";